import {useState, useEffect, useRef} from "react";
import {FormContainer} from "./FormWrapperStyle";
import Loader from "../../components/loader/loader";
import ReCAPTCHA from "react-google-recaptcha";
import axios from "axios";
import Success from "../../components/animation/successIcon";
import Modal from "../../components/modal/modal";
import { useTranslation } from "react-i18next";

const Form = () => {
    const [name, setName] = useState("");
    const [lastname, setLastname] = useState("");
    const [email, setEmail] = useState("");
    const [mobileNumber, setMobileNumber] = useState("");
    const [message, setMessage] = useState("");
    const [textarea, setTextarea] =useState("");
    const [isValidEmail, setIsValidEmail] = useState(true);
    const [isValid, setIsValid] = useState(true);
    const [loading, setLoading] = useState(false);
    const [captchaCompleted, setCaptchaCompleted] = useState(false);
    const [value , setValue] = useState("[empty]")
    const [isSendedForm, setIsSendedForm] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const { t } = useTranslation();
    const handleSubmit = async (e) => {
        e.preventDefault();
        const isTextareaValid = textarea.trim().length >= 1;
        setIsValid(isTextareaValid);
        const token = captchaRef.current.getValue();
        const data = {
            Firstname: name,
            Email: email,
            Lastname: lastname,
            Message: textarea,
            Phone: mobileNumber,
            Captcha:token
        }
        if(isTextareaValid && captchaCompleted && isValidEmail) {
            setLoading(true)
            try {
                const res = await axios.post("https://wbbcksrv.procreditbank.ge/", data, {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                });
                if (res.status === 200) {
                    setLoading(false)
                    // captchaRef.current.reset();
                    setCaptchaCompleted(false)
                    setMessage("შეტყობინება გაიგზავნა");
                    setIsSendedForm(true);
                } else {
                    setMessage("Some error occured");
                }
            } catch (err) {
                console.log(err);
            }
        }
    };

    const handleInputChange = (e) => {
        if (/^[0-9,+]{0,13}$/.test(e.target.value)){
            setMobileNumber(e.target.value)
        }
    };

    const textareaChange = (event) =>{
        const value = event.target.value;
        if(/^\W*(?:\w+\b\W*){0,300}$/.test(value)) {
            setTextarea(value);
            const isValidValue = value.trim().length >= 1;
            setIsValid(isValidValue);
        }

    };
    const names = (e) =>{
        if(/^[a-zA-Z-ა-ჰ]*$/.test(e.target.value)) {
            setName(e.target.value)
        }
    };
    const lastnames = (e) =>{
        if(/^[a-zA-Z-ა-ჰ]*$/.test(e.target.value)) {
            setLastname(e.target.value)
        }
    };
    const handleInputChanges = (event) => {
        const emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const value = event.target.value;
        setEmail(value);
        const isValid = emailRegex.test(value);
        setIsValidEmail(isValid);
        if (value.trim() === "") {
            setIsValidEmail(true)
        }
    };
    const TEST_SITE_KEY = "6Ld1sHEnAAAAAG5cvT_G6g9fmP2wR9uX8n1Y8NRN";
    const captchaRef = useRef(null)
    const handleCaptchaChange = value => {
        setValue(value);
        setCaptchaCompleted(!!value);
    };
    const DELAY = 2000;
    useEffect(() => {
        setTimeout(() => {
            setShowModal(true);
        }, DELAY);
 
      }, []);
      const language = window.location.pathname.substring(
        window.location.pathname.length - 3
      );
    const languageLoader = () =>(language === "/ka" && "ka") ||(language === "/en" && "en") ||localStorage.getItem("culture") ||"ka";
    return (

        <FormContainer>
            {!isSendedForm && (
            <form onSubmit={handleSubmit}>

                <div className="row">
                    <div className="column">
                        <div className="floating">
                            <input id="username" className="floating__input" name="username" type="text" placeholder="სახელი" value={name} onChange={names} />
                            <label htmlFor="username" className="floating__label" data-content={t('username')}>
                                <span className="hidden--visually">Username</span></label>
                        </div>
                    </div>
                    <div className="column">
                        <div className="floating">
                            <input id="lastname" className="floating__input" name="username" type="text" placeholder="გვარი"  onChange={lastnames} value={lastname} />
                            <label htmlFor="lastname" className="floating__label" data-content={t('surname')}>
                                <span className="hidden--visually">lastname</span></label>
                        </div>
                </div>
                </div>
                <div className="row">
                    <div className="column">
                        <div className="floating">
                            <input id="mobileNumber" className="floating__input" name="username" type="text" placeholder="ტელეფონის ნომერი"  onChange={handleInputChange} value={mobileNumber} />
                            <label htmlFor="mobileNumber" className="floating__label" data-content={t('mobileNumber')}>
                                <span className="hidden--visually">mobileNumber</span></label>
                        </div>
                    </div>
                    <div className="column  h-100">
                        <div className="floating">
                            <input id="email" className="floating__input" name="username" type="text" placeholder="ელ.ფოსტა"  onChange={handleInputChanges} value={email} />
                            <label htmlFor="email" className="floating__label" data-content={t('email')}>
                                <span className="hidden--visually">email</span></label>
                        </div>
                        <div className=""> {isValidEmail ? null : <p  className="errorText" >{t('error1')}</p>}</div>

                    </div>
                </div>

                <div className="row">
                    <div className="column h-300">
                        <div className="floating">
                <textarea
                    value={textarea}
                    id="textarea"
                    placeholder="შეტყობინება"
                    onChange={textareaChange}
                    onBlur={textareaChange}
                    className="floating__input" 
                />
                        <label htmlFor="email" className="floating__label_textarea" data-content={t('message')}>
                                <span className="hidden--visually">email</span></label>
                        </div>
                        {isValid ? null : <p  className="errorText" >{t('error2')}</p>}
                    </div>

                </div>

                <div className="row">
                    <div className="column">
                        <ReCAPTCHA
                            style={{ display: "inline-block" }}
                            theme="light"
                            ref={captchaRef}
                            sitekey={TEST_SITE_KEY}
                            onChange={handleCaptchaChange}
                            hl = {languageLoader()}

                        />
                    </div>
                </div>
                <div className="row">
                    <div className="column">
                        <button type="submit"  disabled={loading}> 
                        {!loading ? `${t('send')}` : <Loader/>}
                        </button>

                    </div>
                </div>
                <div className="message">{message ? <p>{message}</p> : null}</div>
                {
                    showModal ? <Modal className="fade-up" toggleModal={setShowModal} /> : null
                }
            </form>
            )}
            {isSendedForm && (
                <div className="result">
                    <div className="result-icon">  <Success/></div>
                    <div className="result-title"><h1>{t('result')}</h1></div>
                    {name === "" || !name ? (
                        <div className="result-subtitle">{t('modalText')}</div>
                        ) : null }
                </div>
            )}
        </FormContainer>
    );


};
export default Form;